import React from "react";
import AuditQueue from "./AuditQueue";

const AgDashboard = () => (
  <AuditQueue
    type="releases"
    stage={1}
    title="AG Dashboard"
    subtitle="Releases at Budget Approval Released waiting for the Auditor General."
  />
);

export default AgDashboard;
